/* eslint-disable @typescript-eslint/naming-convention */
export enum ItemPickerTypeEnum {
	ENVIRONMENT,
	BUSINESS_UNIT,
	DHL_LOGGING_STYLE,
	SSTN_LOGGING_STYLE,
	DESCRIPTIONS
}
